// socket.js
import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:7289"
    : `https://api.${process.env.REACT_APP_DOMAIN}`;

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: false, // <-- don’t connect until we call .connect()
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

/**
 * Initialize (or re-initialize) the socket with a new token and connect.
 */
export function initSocket(token) {
  socket.auth = { token };
  socket.connect();
}

/**
 * Gracefully disconnect the socket.
 */
export function closeSocket() {
  if (socket.connected) {
    socket.disconnect();
  }
}

/* export const connectSocket = (token) => {
  const baseURL =
      process.env.NODE_ENV === "development"
        ? `http://localhost:7289`
        : `https://api.${process.env.REACT_APP_DOMAIN}`,
    socket = io(baseURL, {
      withCredentials: true,
      auth: {
        token,
      },
    });

  socket.on("connect", () => {
    console.log("Socket connected:", socket.id);
  });

  socket.on("disconnect", () => {
    console.log("Socket disconnected");
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
 */
